import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

// Check if URL should include credentials (exclude external APIs like api.menutech.com)
const shouldIncludeCredentials = (url: string): boolean =>
  !url.includes('api.menutech.com') && !url.includes('devapi.menutech.com');

@Injectable({
  providedIn: 'root',
})
export class GenericsService {
  private http = inject(HttpClient);

  get = <O>(
    url: string,
    params?: any,
    headers?: any,
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
  ) =>
    this.http.get<O>(url, {
      params,
      headers,
      responseType: (responseType ?? 'json') as any,
      withCredentials: shouldIncludeCredentials(url),
    });

  post = <I, O>(url: string, data: I, params?: any, headers?: any) =>
    this.http.post<O>(url, data, {
      params,
      headers,
      withCredentials: shouldIncludeCredentials(url),
    });

  patch = <I, O = I>(url: string, data: I, params?: any) =>
    this.http.patch<O>(url, data, {
      params,
      withCredentials: shouldIncludeCredentials(url),
    });

  delete = <O>(url: string, params?: any, body?: object) =>
    this.http.delete<O>(url, {
      params,
      body,
      withCredentials: shouldIncludeCredentials(url),
    });
}
